export default function FavoritesPage({ favoritePets, removeFromFavorites }) {
  return (
    <div className="results-container">
      <h1 className="results-title">Your Favorite Pets ❤️</h1>
      
      {favoritePets.length === 0 ? (
        <p style={{ textAlign: 'center', color: 'white', fontSize: '1.2rem' }}>
          No favorites yet! Go back and add some pets to your favorites.
        </p>
      ) : (
        favoritePets.map((pet) => (
          <div
            key={pet.id}
            className="pet-card"
            style={{ position: "relative", overflow: "hidden" }}
          >
            <img
              className="pet-image"
              src={pet.image}
              alt={`${pet.breed} named ${pet.name}`}
            />
            <h3 className="pet-name">{pet.name}</h3>
            <p className="pet-info">
              {pet.age} years old • {pet.breed}
            </p>
            <p className="match-percentage">92% Match!</p>
            <button className="learn-more-button">Learn More</button>
            <button 
              onClick={() => removeFromFavorites(pet.id)} 
              className="card-favorite-button"
              style={{ fontSize: '1.2rem' }}
            >
              ✕
            </button>
          </div>
        ))
      )}
    </div>
  );
}